import React from "react"
import PropTypes from "prop-types"

export default function InputContainer(props){
	return(
		<div className={"input-container"}>
			<p>{props.title}</p>
			{props.children}
		</div>
	)
}

InputContainer.propTypes = {
	title: PropTypes.string.isRequired
}